import axios from "axios";

export const createChangeIdea = async (username, changeIdeaVO) => {
    try {
        const {data} = await axios.post("/api/changeIdea/create", {username, changeIdeaVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateChangeIdea = async (username, changeIdeaVOToUpdate) => {
    try {
        const {data} = await axios.put("/api/changeIdea/update", {username, changeIdeaVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewChangeIdea = async (username, changeIdeaExternalReference) => {
    try {
        const {data} = await axios.post("/api/changeIdea/view", {username, changeIdeaExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewAllChangeIdeas = async (username) => {
    try {
        const {data} = await axios.get("/api/changeIdea/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewChangeIdeasForCause = async (username, causeExternalReference) => {
    try {
        const {data} = await axios.post("/api/changeIdea/viewChangeIdeasForCause" , {username, causeExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewChangeIdeasForPackage = async (username, changeIdeaPackageExternalReference) => {
    try {
        const {data} = await axios.post("/api/changeIdea/viewChangeIdeasForPackage" , {username, changeIdeaPackageExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteChangeIdea = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/changeIdea/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const findChangeIdeasByCriteria = async (username, trackerSearchInput) => {
    try {
        const {data} = await axios.post("/api/changeIdea/findChangeIdeasByCriteria" , {username, trackerSearchInput});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
